exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-picklist {\n  width: 100%;\n  height: 100%;\n  border: 1px solid #D7D7D7;\n  outline: none; }\n\n.option-picklist {\n  padding: 8px;\n  font-size: 13px;\n  color: #707070 !important; }\n\noption:checked {\n  box-shadow: 0 0 10px 100px #909090 inset; }\n\n.btn-picklist {\n  font-size: 25px;\n  width: 50px;\n  height: 50px; }\n\n.row {\n  margin-top: 10px; }\n\n.botoes-picklist {\n  text-align: -webkit-center;\n  display: -ms-grid;\n  display: grid;\n  padding-top: 40px;\n  padding-bottom: 40px; }\n\n.btn-navegacao {\n  margin-right: 8px; }\n\n.rotulo-select {\n  color: #707070;\n  text-transform: uppercase;\n  font-weight: bold; }\n\n.picklist {\n  border: 1px solid #D7D7D7 !important;\n  margin-top: 15px; }\n\n.picklist-content {\n  margin: 15px; }\n\n.btn-adicionar-todos {\n  background-color: #32C787 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/picklist/picklist.component.scss
// module id = ../../../../../src/app/angular-base-ui/picklist/picklist.component.scss
// module chunks = 1